import adminApi from "../axios";

function dataOf(response) {
  return response?.data?.data ?? response?.data ?? [];
}

function authConfig(extra = {}) {
  return {
    ...extra,
    headers: {
      ...extra.headers,
      Authorization: `Bearer ${localStorage.getItem("@token")}`,
    },
  };
}

export function getApiError(error, fallback = "Something went wrong") {
  const body = error?.response?.data;
  if (Array.isArray(body?.details) && body.details.length) {
    return body.details.join(". ");
  }
  return body?.error || body?.message || error?.message || fallback;
}

export async function listCourses(params = {}) {
  return dataOf(await adminApi.get("courses", authConfig({ params })));
}

export async function getCourse(courseId) {
  return dataOf(await adminApi.get(`courses/${courseId}`, authConfig()));
}

export async function createCourse(payload) {
  return dataOf(await adminApi.post("courses", payload, authConfig()));
}

export async function updateCourse(courseId, payload) {
  return dataOf(await adminApi.put(`courses/${courseId}`, payload, authConfig()));
}

export async function updateCourseStatus(courseId, status) {
  return dataOf(
    await adminApi.patch(`courses/${courseId}/status`, { status }, authConfig())
  );
}

export async function listMusicFields() {
  return dataOf(await adminApi.get("musicFields", authConfig()));
}

export async function listOrganizations() {
  return dataOf(
    await adminApi.get("organizations", authConfig({ params: { status: "ACTIVE" } }))
  );
}

export async function listGurus() {
  const users = dataOf(await adminApi.get("users", authConfig()));
  return Array.isArray(users)
    ? users.filter((user) => String(user.role).toLowerCase() === "guru")
    : [];
}
